import {RPCDocs} from '@therms/rpc-gateway'

interface MapImportDataToRecordFieldsProps {
  importData: Record<string, any>
  recordType:
    | RPCDocs.Records.CreateRecord.v1.Type
    | RPCDocs.Records.BulkCreateRecords.v1.Type
}

export function mapImportDataToRecordFields({
  importData,
  recordType,
}: MapImportDataToRecordFieldsProps) {
  const mappedData: RPCDocs.Records.BulkCreateRecords.v1.Record[] = []

  for (let i = 0; i < importData.length; i++) {
    mappedData.push({
      fields: {
        additional: importData[i].additional,
        age: importData[i].age,
        alias: importData[i].alias,
        approxAge: importData[i].approxAge,
        brand: importData[i].brand,
        color: importData[i].color,
        criminalAuthority: importData[i].criminalAuthority,
        criminalId: importData[i].criminalId,
        dob: importData[i].dob,
        email: importData[i].email,
        eyes: importData[i].eyes,
        gender: importData[i].gender,
        hair: importData[i].hair,
        height: importData[i].height,
        idAuthority: importData[i].idAuthority,
        idNumber: importData[i].idNumber,
        locality: importData[i].locality,
        make: importData[i].make,
        model: importData[i].model,
        name: importData[i].name,
        phone: importData[i].phone,
        plate: importData[i].plate,
        race: importData[i].race,
        region: importData[i].region,
        size: importData[i].size,
        ss: importData[i].ss,
        status: importData[i].status,
        streetAddress: importData[i].streetAddress,
        style: importData[i].style,
        type: importData[i].type,
        vin: importData[i].vin,
        weight: importData[i].weight,
        year: importData[i].year,
      },
      type: recordType as RPCDocs.Records.BulkCreateRecords.v1.Type,
    })
  }

  return mappedData
}
